var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLastWorkoutSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1011_43751)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.52487,
    height: 12.4434,
    rx: 1,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 21.9648 11.0708)",
    stroke: "#33A9A0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.39365,
    height: 5.65609,
    rx: 1,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 23.207 15.7065)",
    stroke: "#33A9A0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.25,
    y: 3.15234,
    width: 4.52487,
    height: 12.4434,
    rx: 1,
    transform: "rotate(30 8.25 3.15234)",
    stroke: "#33A9A0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.61719,
    y: 4.39453,
    width: 3.39365,
    height: 5.65609,
    rx: 1,
    transform: "rotate(30 3.61719 4.39453)",
    stroke: "#33A9A0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.5L8.5 10.5",
    stroke: "#33A9A0",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1011_43751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastWorkoutSession);
export default __webpack_public_path__ + "static/media/last-workout-session.babbe24048f8264402e28b3654e76de2.svg";
export { ForwardRef as ReactComponent };